import { Box } from "@mui/material";
import { styled } from "@mui/material";
import { Poppins } from "next/font/google";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

export const DrawerBodyContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  fontFamily: poppins.style.fontFamily,
}));
